const constants = {
  MAX_HOLIDAY_LENGTH: 150,
  MAX_DESCRIPTION_LENGTH: 500,
  STATIC_DATE_RANGE_LIST: [
    { label: '2 days', value: 2 },
    { label: '1 week', value: 7 },
    { label: '2 week', value: 14 }
  ]
};

export { constants };
